<li class="m-option-title">
    <slot />
</li>
